module.exports = {
  amplitudeFeatureFlag: {
    flags: {
      agentBrandingIsPaidFeatureEnabled: "agent_branding_ispaid_feature_enabled",
    },
  },
};
